import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import VisualIVRMenuBlockData from '../../../Models/Content/VisualIVRMenuBlockData';
import VisualIVRStepManager from './VisualIVRStepManager';


export default class VisualIVRMenuBlock extends EpiComponent<VisualIVRMenuBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <VisualIVRStepManager context={this.getContext()} contentData={this.props.data} />;
  }
}
